import React, { Fragment, useRef, useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from '@headlessui/react'
import Spinner from '../Spinner';
import { addShaunEllisResponse } from '../../redux/actions/profileDetails';

const ShaunEllisPopup = ({ openSEPopup, setOpenSEPopup }) => {
    const dispatch = useDispatch()
    const user_id = useSelector(store => store?.profileDetails?.id)
    const [selectedOption, setSelectedOption] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [isResponse, setIsResponse] = useState(false)
    const cancelButtonRefSE = useRef(null)
    const options = [
        {
            title: 'Very Disappointed',
            emoji: '😟',
            percentage: 62.1,
            responseCount: 13,
            // percentage: (shaunEllisAnalytics?.option_1 / shaunEllisAnalytics?.total_responses * 100).toFixed(1),
            // responseCount: shaunEllisAnalytics?.option_1,
        },
        {
            title: 'Somewhat Disappointed',
            emoji: '😑',
            percentage: 83.9,
            responseCount: 24,
            // percentage: (shaunEllisAnalytics?.option_2 / shaunEllisAnalytics?.total_responses * 100).toFixed(1),
            // responseCount: shaunEllisAnalytics?.option_2,
        },
        {
            title: "Not Disappointed (it really isn't useful)",
            emoji: '😬',
            percentage: 13.1,
            responseCount: 5,
            // percentage: (shaunEllisAnalytics?.option_3 / shaunEllisAnalytics?.total_responses * 100).toFixed(1),
            // responseCount: shaunEllisAnalytics?.option_3,
        },
        {
            title: 'N/A - I no longer use this product',
            emoji: '🙄',
            percentage: 7.1,
            responseCount: 3,
            // percentage: (shaunEllisAnalytics?.option_4 / shaunEllisAnalytics?.total_responses * 100).toFixed(1),
            // responseCount: shaunEllisAnalytics?.option_4,
        },
    ]

    const callback = () => {
        setIsLoading(false)
        setIsResponse(true)
    }

    const submitHandler = () => {
        setIsLoading(true)
        dispatch(addShaunEllisResponse(selectedOption + 1, user_id, callback))
    }

    return (
      <Transition.Root show={openSEPopup} as={Fragment}>
            <Dialog
                as="div"
                className="fixed z-10 inset-0 overflow-y-auto"
                initialFocus={cancelButtonRefSE}
                onClose={setOpenSEPopup}
            >
                <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                        &#8203;
                    </span>
                    <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div
                            className="relative inline-block align-middle bg-white rounded-md text-left overflow-hidden shadow-xl transform transition-all"
                        >
                            <div className="bg-white px-4 pt-5 pb-4 sm:pt-12 sm:px-16 sm:pb-4">
                                <div className="sm:flex sm:items-start">
                                    <div className="mt-3 text-center sm:mt-0 sm:text-left">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg lg:text-2xl leading-6 font-medium text-gray-900 bold"
                                    >
                                        How would you feel if you could no longer use LearnTube app ?
                                    </Dialog.Title>
                                    <ul className="mt-10">
                                        {options.map((option, i) =>
                                            <li
                                                key={option.title}
                                                className={`my-4 font-semibold rounded-sm ${!isResponse && selectedOption === i ? 'bg-teal-500' : 'bg-white'} ${!isResponse && 'cursor-pointer hover:ring-2 hover:ring-offset-2 hover:ring-teal-500'}`}
                                                style={{ color: '#0B5245' }}
                                                onClick={() => setSelectedOption(i)}
                                            >
                                                <div className="relative border-2 border-teal-500 rounded-sm flex text-sm sm:text-md">
                                                    <div className="mt-3 px-4 w-10 align-center text-center flex">
                                                        {i + 1}
                                                    </div>
                                                    <div className="flex-1 text-left relative flex">
                                                        <div className="p-2 z-10 text-md" style={{ maxWidth: '70%' }}>
                                                            <spam className="text-lg">{option.emoji}</spam> {option.title}
                                                        </div>
                                                        {isResponse && <div className="bg-teal-500 absolute w-full h-full" style={{maxWidth: `${option?.percentage}%`}}></div>}
                                                    </div>
                                                    {isResponse && <div className='absolute right-0 mr-4 mt-3'>
                                                        <span className="pr-4">{option?.percentage}%</span>
                                                        <span>{option?.responseCount}</span>
                                                    </div>}
                                                </div>
                                            </li>
                                        )}
                                    </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse mb-2">
                                <button
                                    type="button"
                                    className={`w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2  sm:ml-3 sm:w-auto sm:text-sm ${!isResponse ? 'bg-teal-600 hover:bg-teal-700 focus:ring-teal-500' : 'bg-gray-600'}`}
                                    style={{minWidth: '100px'}}
                                    onClick={submitHandler}
                                    disabled={isResponse}
                                >
                                    {!isResponse ? !isLoading ? 'Submit Response' : <Spinner className={"w-4 h-4 flex justify-evenly items-center scale-125"}></Spinner> : 'Response Submitted'}
                                </button>
                                <button
                                    type="button"
                                    className="mt-2 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-10 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-500 hover:text-white focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                    onClick={() => setOpenSEPopup(false)}
                                    ref={cancelButtonRefSE}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
      </Transition.Root>
    )
}

export default ShaunEllisPopup
